import { Briefcase, Building, Lock, Mail } from "lucide-react";
import type React from "react";
import { useState } from "react";
import UpdatePasswordModal from "./UpdatePasswordModal";

interface DetailsProps {
  initials: string;
  firstName: string;
  lastName: string;
  username: string;
  merchantName: string;
  role: string | null;
}

const Details: React.FC<DetailsProps> = ({
  initials,
  firstName,
  lastName,
  username,
  merchantName,
  role,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div>
      <div>
        {/* Header with background color */}
        <div className="bg-gradient-to-r from-slate-700 to-slate-900 h-32 sm:h-40"></div>

        <div className="px-4 sm:px-6 lg:px-8 pb-8 -mt-16">
          {/* Avatar */}
          <div className="flex flex-col sm:flex-row items-center sm:items-end">
            <div className="h-24 w-24 sm:h-32 sm:w-32 rounded-full bg-slate-600 flex items-center justify-center text-white text-3xl font-bold border-4 border-white shadow-md">
              {initials}
            </div>

            <div className="mt-4 sm:mt-0 sm:ml-6 text-center sm:text-left">
              <h1 className="text-2xl font-bold text-gray-900">
                {firstName} {lastName}
              </h1>
              <p className="text-gray-500 flex items-center justify-center sm:justify-start mt-1">
                <Mail className="h-4 w-4 mr-1" />
                {username}
              </p>
            </div>

            <div className="ml-auto mt-4 sm:mt-0">
              <button
                onClick={openModal}
                className="flex items-center px-4 py-2 bg-slate-700 hover:bg-slate-800 text-white rounded-md transition duration-200"
              >
                <Lock className="h-4 w-4 mr-2" />
                Update Password
              </button>
            </div>
          </div>

          {/* Profile information */}
          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gray-50 rounded-xl p-6 shadow-sm">
              <div className="flex items-center">
                <Building className="h-5 w-5 text-slate-700" />
                <h2 className="ml-2 text-lg font-semibold text-gray-900">
                  Company
                </h2>
              </div>
              <div className="mt-4">
                <p className="text-gray-700 capitalize">{merchantName}</p>
              </div>
            </div>

            <div className="bg-gray-50 rounded-xl p-6 shadow-sm">
              <div className="flex items-center">
                <Briefcase className="h-5 w-5 text-slate-700" />
                <h2 className="ml-2 text-lg font-semibold text-gray-900">
                  Role
                </h2>
              </div>
              <div className="mt-4">
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-slate-100 text-slate-800">
                  {role}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Password Update Modal */}
      <UpdatePasswordModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
};

export default Details;
